import { ApplicationConfig, provideAppInitializer, inject, provideZoneChangeDetection, isDevMode } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideServiceWorker } from '@angular/service-worker';
import { firstValueFrom, of, switchMap, tap } from 'rxjs';
import { routes } from './app.routes';
import { clientSessionInterceptor } from './core/interceptors/client-session.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { BrandingStore } from './core/stores/branding.store';
import { BrandingRefreshService } from './core/services/branding/branding-refresh.service';
import { BrandingTitleService } from './core/services/branding/branding-title.service';
import { TenantContextService } from './core/services/tenant-context/tenant-context.service';
import { ClientSessionService } from './core/services/client-session/client-session.service';
import { PortalManifestService } from './core/services/manifest/portal-manifest.service';
import { SessionTimeoutService } from './core/services/session-timeout/session-timeout.service';
import { NetworkStatusService } from './core/services/network-status/network-status.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([clientSessionInterceptor, errorInterceptor])
    ),
    provideAppInitializer(() => {
      const branding = inject(BrandingStore);
      const session = inject(ClientSessionService);
      const manifest = inject(PortalManifestService);
      const tenant = inject(TenantContextService);
      return firstValueFrom(
        tenant.resolve().pipe(
          tap(() => manifest.apply(tenant.tenantHash())),
          switchMap((companyId) => (companyId ? branding.load(companyId) : of(null))),
          switchMap((config) => (config ? session.restoreFromCookie() : of(null))),
          switchMap((restored) => session.enforceTenant(restored, tenant.companyId()))
        )
      );
    }),
    provideAppInitializer(() => {
      inject(BrandingRefreshService);
      inject(BrandingTitleService);
      inject(SessionTimeoutService);
      inject(NetworkStatusService);
    }),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ]
};
